<template>
  <span :class="badgeClass" v-if="status" class="badge fw-bold px-3 py-2">
    {{ status | formatPaymentStatus }}
  </span>
</template>

<script>
export default {
  props: ['status'],
  computed: {
    badgeClass () {
      const badgeMap = {
        PAID: 'badge-light-success',
        PENDING: 'badge-light-warning',
        PROCESSING: 'badge-light-warning',
        AUTHORIZED: 'badge-light-warning',
        REFUNDED: 'badge-light-primary',
        WAITING_PAYMENT: 'badge-light-warning',
        PENDING_REFUND: 'badge-light-warning',
        REFUSED: 'badge-light-danger',
        CHARGEDBACK: 'badge-light-danger',
        EXPIRED: 'badge-light-dark',
        CANCELED: 'badge-light-danger'
      }
      return badgeMap[this.status] || 'badge-light-dark'
    }
  }
}
</script>

<style lang="scss" scoped>
  .badge-light-primary {
    background-color: rgba(216, 171, 68, .15) !important;
  }
</style>
